/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Contact_Client_TitleInputs */

const en_platform_contact_client_title = /** @type {(inputs: Platform_Contact_Client_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Looking for your own coach?`)
};

const pl_platform_contact_client_title = /** @type {(inputs: Platform_Contact_Client_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szukasz swojego trenera?`)
};

/**
* | output |
* | --- |
* | "Looking for your own coach?" |
*
* @param {Platform_Contact_Client_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_contact_client_title = /** @type {((inputs?: Platform_Contact_Client_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Contact_Client_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_contact_client_title(inputs)
	return en_platform_contact_client_title(inputs)
});